__webpack_require__.p = "/React_speed_game/";